// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
  /** The spec marks this field readOnly, so no request body may carry it. */
  readOnly?: boolean
}

export const creditAgenciesResponseSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
    readOnly: true,
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
    readOnly: true,
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
    readOnly: true,
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
    readOnly: true,
  },
  {
    key: 'companyId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'companyId',
    readOnly: true,
  },
  {
    key: 'agencyName',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'agencyName',
    options: ['experian', 'equifax', 'transUnion', 'innovis'],
  },
  {
    key: 'country',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'country',
  },
  {
    key: 'dataFormat',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'dataFormat',
    options: ['metro2'],
  },
  {
    key: 'nameFilePerAgencyConvention',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'nameFilePerAgencyConvention',
  },
  {
    key: 'fileNamePrefix',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'fileNamePrefix',
  },
  {
    key: 'isPeachAggregator',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'isPeachAggregator',
  },
  {
    key: 'sftpAccessMethod',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'sftpAccessMethod',
    options: ['usernamePassword', 'keys'],
  },
  {
    key: 'sftpSSHPeachPublicKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpSSHPeachPublicKey',
    readOnly: true,
  },
  {
    key: 'sftpSSHPeachPrivateKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpSSHPeachPrivateKey',
    readOnly: true,
  },
  {
    key: 'sftpHostname',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpHostname',
  },
  {
    key: 'sftpUsername',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpUsername',
  },
  {
    key: 'sftpPassword',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpPassword',
  },
  {
    key: 'sftpCdDir',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'sftpCdDir',
  },
  {
    key: 'encryptionMethod',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'encryptionMethod',
    options: ['', 'GPG'],
  },
  {
    key: 'publicKey',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'publicKey',
  },
  {
    key: 'uploadFrequency',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'uploadFrequency',
    options: ['monthly'],
  },
  {
    key: 'specificDays',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'specificDays',
    nested: [
      {
        key: '0',
        type: 'number',
        required: true,
        component: 'NumberInput',
        fullPath: 'specificDays[0]',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'useLoanExternalId',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'useLoanExternalId',
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(creditAgenciesResponseSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(creditAgenciesResponseSchema)
}
